<template>
  <div class="full-container service">
    <apj-page-banner :options="options"></apj-page-banner>
    <div
      class="container introduce-container"
      style="padding-top: 50px; padding-bottom: 0px"
    >
      <div class="title">教培机构 · 一站解决运营难题</div>
    </div>
    <div class="container info-organization">
      <div
        class="organization-item"
        v-for="(item, index) in pageData.organization"
        :key="'organization' + index"
      >
        <el-image
          class="organization-icon"
          :src="item.img"
          fit="contain"
        ></el-image>
        <div class="organization-content">
          <span class="item-title">{{ item.title }}</span>
          <span class="item-sub-title">{{ item.subTitle }}</span>
        </div>
      </div>
    </div>

    <div
      class="container introduce-container"
      style="padding-top: 50px; padding-bottom: 0px"
    >
      <div class="title">知识付费 · 快速搭建自己的知识店铺</div>
    </div>
    <div class="container info-knowladge">
      <div
        class="knowladge-item"
        v-for="(item, index) in pageData.knowladge"
        :key="'knowladge' + index"
      >
        <el-image
          class="knowladge-icon"
          :src="item.img"
          fit="contain"
        ></el-image>
        <span class="item-title" style="margin-bottom: 30px">{{
          item.title
        }}</span>
        <span class="item-sub-title">{{ item.subTitle }}</span>
      </div>
    </div>

    <div
      class="container introduce-container"
      style="padding-top: 50px; padding-bottom: 0px"
    >
      <div class="title">企业内训 · 学习型组织标配</div>
    </div>
    <div class="container info-enterprese">
      <div style="padding: 0 10px">
        <div
          class="enterprese-item"
          v-for="(item, index) in pageData.enterprese"
          :key="'enterprese' + index"
        >
          <div class="enterprese-icon-box">
            <el-image
              class="enterprese-icon"
              :src="item.img"
              fit="contain"
            ></el-image>
          </div>
          <div class="enterprese-content">
            <span class="item-title">{{ item.title }}</span>
            <span class="item-sub-title">{{ item.subTitle }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="container info-characteristic">
      <div
        class="characteristic-item"
        v-for="(item, index) in pageData.characteristic"
        :key="'characteristic' + index"
      >
        <div class="characteristic-content pi-pd-lr-40s">
          <span class="item-title" style="font-size: 30px; font-weight: bold">{{
            item.title
          }}</span>
          <span class="item-sub-title">{{ item.subTitle }}</span>
        </div>
        <el-image
          v-if="index == 0 || index == 1"
          class="characteristic-icon"
          :src="item.img"
          fit="contain"
        ></el-image>
        <div
          class="characteristic-text"
          v-if="index == 2 || index == 3"
          :style="{
            'background-image': 'url(' + item.img + ')',
            'background-position': index == 2 ? 'right' : 'left',
            'justify-content': index == 2 ? 'flex-start' : 'flex-end',
          }"
        >
          <ul>
            <li v-for="lItem in item.desc" :key="lItem">{{ lItem }}</li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="container introduce-container"
      style="padding-top: 50px; padding-bottom: 0px"
    >
      <div class="title">为什么选择实训邦云课堂？</div>
    </div>
    <div class="container info-why">
      <div
        class="why-item"
        v-for="(item, index) in pageData.why"
        :key="'why' + index"
        :style="{ 'background-image': 'url(' + item.img + ')' }"
      >
        <div class="why-content">
          <span class="item-title" style="margin-bottom: 10px">{{
            item.title
          }}</span>
          <span class="item-sub-title">{{ item.subTitle }}</span>
        </div>
      </div>
    </div>

    <div
      class="full-container edu-get"
      :style="{ 'background-image': 'url(' + getImg + ')' }"
    >
      <div class="get-title">立即拥有您的专属云课堂</div>
      <div class="get-button" @click="openUrl('http://educloud.sxbang.net')">
        点击/扫码开始预览
      </div>
      <div class="imgs-box">
        <div class="img-box">
          <el-image class="get-img" :src="mpqr[0]"></el-image>
          <span>微信小程序版预览二维码</span>
        </div>
        <div class="img-box">
          <el-image class="get-img" :src="mpqr[1]"></el-image>
          <span>H5版预览二维码</span>
        </div>
      </div>
    </div>

    <div class="info-service-container">
      <div
        class="introduce-container"
        style="padding-top: 50px; padding-bottom: 0px"
      >
        <div class="title">优秀技术研发团队保驾护航</div>
      </div>
      <div class="info-service">
        <div
          class="service-item"
          v-for="(item, index) in pageData.service"
          :key="'service' + index"
        >
          <el-image
            class="service-icon"
            :src="item.img"
            fit="contain"
          ></el-image>
          <span class="item-title" style="margin-bottom: 10px">{{
            item.title
          }}</span>
          <span class="item-sub-title">{{ item.subTitle }}</span>
        </div>
      </div>
    </div>

    <div
      class="container introduce-container"
      style="padding-top: 50px; padding-bottom: 0px"
    >
      <div class="title">实训邦云课堂功能介绍</div>
    </div>
    <div class="container info-introduction">
      <div
        class="introduction-item"
        v-for="(item, index) in pageData.introduction"
        :key="'introduction' + index"
      >
        <el-image
          class="introduction-icon"
          :src="item.img"
          fit="contain"
        ></el-image>
        <span class="item-title">{{ item.title }}</span>
        <span
          class="item-sub-title"
          v-for="(lItem, index) in item.desc"
          :key="'item' + index"
          >{{ lItem }}</span
        >
      </div>
    </div>

    <apj-page-contact></apj-page-contact>
  </div>
</template>

<script>
import ApjPageContact from "@/components/apj-page-contact";
import ApjPageBanner from "@/components/apj-page-banner";
import pageData from "./data.js";

export default {
  name: "res",
  components: {
    ApjPageContact,
    ApjPageBanner,
  },
  data() {
    return {
      pageData,
      pageData,
      options: {
        banner: require("@/assets/site/programme_educloud/banner.jpg"),
        title: "实训邦云课堂 · 在线教育解决方案",
        text: "",
      },
      img: [
        require("@/assets/site/programme_atp/img_1.png"),
        require("@/assets/site/programme_atp/img_2.png"),
        require("@/assets/site/programme_atp/img_3.png"),
      ],
      getImg: require("@/assets/site/contact_bg_higher.jpg"),
      contactQrImg: require("@/assets/site/dp_qr.png"),
      mpqr: [
        require("@/assets/site/programme_educloud/mpqr1.jpeg"),
        require("@/assets/site/programme_educloud/mpqr2.png"),
      ],
    };
  },
  mounted() {
    // 进入页面时，菜单是否透明，或不显示阴影，默认为false，这里是示例
    globalEvent.$emit("changeHeaderTransparent", {
      isTransparent: true,
      isNoShadow: false,
    });
    globalEvent.$emit("changeMenu", 3);
    // globalEvent.$emit('pageLoad')
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/theme.scss";

div {
  width: 100%;
}

/** page style */
.edu-introduce {
  align-self: flex-start;
  max-width: 1250px;
}
.introduce-container {
  max-width: 1250px;
  padding: 80px;
}

.introduce-container-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.title {
  padding: 10px 0 30px;
  font-size: 30px;
  font-weight: bold;
}

.item-title {
  font-size: 20px;
  margin-bottom: 10px;
  font-weight: bold;
}

// 教培机构 · 一站解决运营难题
.info-organization {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;

  .organization-item {
    width: calc(50% - 20px);
    margin: 10px 10px;
    padding: 20px 40px;
    display: flex;
    align-items: flex-start;
    text-align: left;
    border: 1px solid $color-border-grey;
    border-left: 5px solid $color-border-primary;

    .organization-content {
      display: flex;
      flex-direction: column;
    }

    .organization-icon {
      margin-right: 10px;
      width: 50px;
    }
  }
}

// 知识付费 · 快速搭建自己的知识店铺
.info-knowladge {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .knowladge-item {
    width: calc(50% - 20px);
    min-height: 320px;
    margin: 10px 10px;
    padding: 50px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border: 1px solid $color-border-grey;

    .knowladge-content {
      display: flex;
      flex-direction: column;
    }

    .knowladge-icon {
      margin-right: 10px;
      margin-bottom: 20px;
      width: 30px;
    }
  }
}

// 企业内训 · 学习型组织标配
.info-enterprese {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;

  .enterprese-item {
    height: 85px;
    margin: 10px 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    border: 1px solid $color-border-grey;

    .enterprese-content {
      padding: 0 50px 0 50px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .item-title {
        margin: unset;
        white-space: nowrap;
        // padding-left: 50px;
        padding-right: 20px;
      }
    }

    .enterprese-icon-box {
      width: 175px;
      height: 85px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: $color-bg-primary;

      .enterprese-icon {
        margin-right: 10px;
        width: 40px;
      }
    }
  }
}

// 特色
.info-characteristic {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;

  .characteristic-item {
    width: calc(50% - 20px);
    min-height: 570px;
    margin: 10px 10px;
    padding: 50px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background-color: $color-bg-grey;

    .characteristic-content {
      display: flex;
      flex-direction: column;
    }

    .characteristic-icon {
      margin-top: 10px;
      height: 350px;
    }

    .characteristic-text {
      width: 100%;
      height: 400px;
      display: flex;
      text-align: left;
      background-repeat: no-repeat;
      background-size: 300px auto;

      // .characteristic-icon {
      //   z-index: 1;
      //   margin-top: 10px;
      //   margin-left: -200px;
      //   min-width: 300px;
      // }

      ul {
        margin: 0;
        padding: 0;
        margin-top: 80px;
      }

      li {
        margin: 0;
        list-style: none;
        z-index: 10;
        white-space: nowrap;
      }

      li:before {
        content: "·";
        font-size: 20px;
        padding-right: 10px;
        color: #25b8e8;
      }
    }
  }
}

// 为什么选择实训邦云课堂？
.info-why {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .why-item {
    min-height: 500px;
    margin: 10px 10px;
    padding: 20px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    text-align: center;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    border: 1px solid $color-border-grey;
    border-bottom: 5px solid $color-border-primary;

    .item-title {
      white-space: nowrap;
      font-weight: bold;
    }

    .why-content {
      display: flex;
      flex-direction: column;
    }

    .why-icon {
      margin-right: 10px;
      margin-bottom: 20px;
      width: 30px;
    }
  }
}

// 优秀技术研发团队保驾护航
.info-service-container {
  max-width: 1200px;
  margin-top: -160px;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: $color-bg-white;
  border-radius: 10px;
  box-shadow: 2px 2px 5px #eeeeee;

  .info-service {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .service-item {
      margin: 10px 10px;
      padding: 20px 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .service-content {
        display: flex;
        flex-direction: column;
      }

      .service-icon {
        margin-bottom: 20px;
        width: 90px;
      }
    }
  }
}

// 实训邦云课堂功能介绍
.info-introduction {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;

  .introduction-item {
    width: calc(25% - 20px);
    margin: 10px 10px;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .introduction-content {
      display: flex;
      flex-direction: column;
    }

    .introduction-icon {
      margin-bottom: 20px;
      width: 50px;
    }
  }
}

.edu-get {
  padding-top: 80px;
  margin-top: 50px;
  height: 650px;

  .get-title {
    font-size: 42px;
    line-height: 84px;
  }
  $buttonHeight: 40px;
  .get-button {
    width: 200px;
    height: $buttonHeight;
    border-radius: $buttonHeight;
    line-height: $buttonHeight;
    background-color: $color-bg-primary;
    color: $color-text-white;
  }
  .get-button:hover {
    cursor: pointer;
    background-color: $color-bg-white;
    color: $color-text-primary;
  }
  .imgs-box {
    display: flex;
    width: 400px;
    justify-content: center;
    .img-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        padding: 10px;
      }
    }
  }
  .get-img {
    margin-top: $buttonHeight;
    width: 150px;
    height: 150px;
  }
}
@media screen and (max-width: 1024px) {
  .container {
    padding: 0 !important;
  }
   .info-why {
    .why-item {
      padding: 20px 10px;
    }
  }
}
@media screen and (max-width: 1439px) {
  .info-why {
    .why-item {
      padding: 20px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/educloud/index.vue